'use client'

import { RenderContentBlocks } from '@/blocks/Content/components'
import { FileText, Shield, Info, HelpCircle, Mail, Phone } from 'lucide-react'

type PageData = {
  title: string
  description?: string | null
  icon?: string | null
  blocks?: any[]
  showLastUpdated?: boolean | null
  updatedAt: string
}

type Props = {
  page: PageData
}

const iconMap = {
  FileText,
  Shield,
  Info,
  HelpCircle,
  Mail,
  Phone,
} as const

export const PageContent = ({ page }: Props) => {
  const IconComponent = page.icon ? iconMap[page.icon as keyof typeof iconMap] : FileText

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
        {/* Header */}
        <header className="mb-10">
          <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
            <IconComponent className="h-6 w-6 text-primary" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            {page.title}
          </h1>
          {page.description && (
            <p className="mt-2 text-lg text-muted-foreground">{page.description}</p>
          )}
        </header>

        {/* Content */}
        <article>
          <RenderContentBlocks blocks={(page.blocks as any) ?? []} className="space-y-8" />
        </article>

        {/* Footer */}
        {page.showLastUpdated && (
          <footer className="mt-12 border-t border-border/50 pt-6">
            <p className="text-sm text-muted-foreground">
              Laatst bijgewerkt:{' '}
              {new Date(page.updatedAt).toLocaleDateString('nl-NL', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}
            </p>
          </footer>
        )}
      </div>
    </div>
  )
}
